

export default [
  {
    title: 'ข้อมูลร้านค้า (ผู้ขาย)',
    icon: 'UserIcon',
    children: [
      {
        title: 'รายการข้อมูล',
        route: 'seller-list',
      },
      {
        title: 'ดูข้อมูล',
        route: { name: 'seller-view', params: { id: 21 } },
        disabled: true,
      },
      // {
      //   title: 'แก้ไขข้อมูล',
      //   route: { name: 'seller-edit', params: { id: 21 } },
      // },
      // {
      //   title: 'เพิ่มข้อมูล',
      //   route: { name: 'seller-add' },
      // },
    ],
  },
]
